import React from "react";
import { PortableTextContent } from "@tennr/frontend/components/PortableTextContent";
import { DynamicText } from "@tennr/frontend/components/DynamicText";
import type { CaseStudy } from "@tennr/frontend/../sanity.types";
import "./CaseStudyDetailContentSection.css";

interface CaseStudyDetailContentSectionProps {
  caseStudy: CaseStudy;
}

export const CaseStudyDetailContentSection: React.FC<CaseStudyDetailContentSectionProps> = ({ caseStudy }) => {
  // Handle both v1 and v2 structures
  const isV2 = (caseStudy as any)._type === "caseStudyV2";

  // For v2, use contentSections; for v1, use the old structure
  const sections = isV2
    ? (caseStudy as any).contentSections || []
    : [caseStudy.challenge, caseStudy.solution, caseStudy.implementation].filter(Boolean);

  return (
    <section className="case-study-detail-content-section">
      <div className="case-study-detail-content-container">
        {sections.map((section: any, index: number) => {
          // Handle v2 structure (structuredContentBlock)
          if (isV2) {
            return (
              <div key={index} className="case-study-detail-content-block">
                {section.body && (
                  <div className="case-study-detail-content-body">
                    <PortableTextContent
                      title={section.title}
                      heading={section.heading}
                      content={section.body}
                      defaultVariant="hero"
                      defaultPosition="left"
                      context="default"
                    />
                  </div>
                )}
                {section.additionalContent && (
                  <div className="case-study-detail-content-additional">
                    <PortableTextContent
                      content={section.additionalContent}
                      defaultVariant="hero"
                      defaultPosition="left"
                      context="case-study"
                    />
                  </div>
                )}
              </div>
            );
          }

          // Handle v1 structure
          return (
            <div key={index} className="case-study-detail-content-block">
              {section.title && <div className="case-study-detail-content-title">{section.title}</div>}
              {section.content && (
                <div className="case-study-detail-content-body">
                  <PortableTextContent content={section.content} defaultVariant="hero" defaultPosition="left" />
                </div>
              )}
            </div>
          );
        })}
        {/* Include the hero description if available (v1 only) */}
        {!isV2 && caseStudy.heroContent?.description && (
          <div className="case-study-detail-content-block">
            <p className="case-study-detail-content-body">{caseStudy.heroContent.description}</p>
          </div>
        )}
      </div>
    </section>
  );
};
